import React from 'react';

import {
  useEventState,
} from './EventContext';

import styles from './Event.module.scss';

import NewEventAttendeesForm from './NewEventAttendeesForm';
import OpenEventInvitationsTable from './OpenEventInvitationsTable';

const EventAdminSection = () => {
  const state = useEventState();

  if (state.loading) {
    return null;
  }

  if (!state?.authenticatedUser?.canAdministerEvents) {
    return null;
  }

  return (
    <div className={styles.event}>
      <hr />
      <NewEventAttendeesForm />
      <hr />
      <OpenEventInvitationsTable />
    </div>
  );
};

export default EventAdminSection;
